import api from "../../services/api";
import { IListOccurrence } from "../../types/occurrence";

export const filterOccurrencesQueryKey = (filterParams: {}) => ['occurrence_list_filter', filterParams];
export const filterOccurrencesParamsQueryKey = () => ['occurrence_list_filter_params'];
export const filterOccurrences = async (params: object) => (await api.get<IListOccurrence>('/schedulling/occurrence/filter', { params })).data;